import { ReactElement, useContext, useEffect, useRef, useState } from "react";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import { useAppDispatch, useAppSelector } from "../../../../../services/hooks.ts";
import { setRules } from "../../../../../stores/cart/checkoutSlice.ts";
import { CheckoutContext } from "../../../../../stores/cart/checkoutContext.ts";
import { useTranslation } from "react-i18next";
import './SiteSummaryConsents.scss'

export default function SiteSummaryConsents() {
    const { t } = useTranslation('cart');

    const labelCheckRules = <small>
        <span className="text-danger">*</span>&nbsp;
        <span>{t('summary.consents.terms')}</span>
    </small>
    const labelCheckPolicy = <small>
        <span className="text-danger">*</span>&nbsp;
        <span>{t('summary.consents.privacy')}</span>
    </small>
    const labelCheckMail = <small>Wyrażam zgodę na otrzymywanie od ROMER S.C. A.CIURA W. CIURA z siedzibą przy ul. Rejowska 99, 26-110 Skarżysko-Kamienna, za pomocą środków komunikacji elektronicznej, na podany przeze mnie adres e-mail, informacji handlowych związanych z działalnością Spółki, w szczególności informacji o produktach oferowanych przez ROMER S.C. A.CIURA W.CIURA. Powyższa zgoda może być wycofana w dowolnym momencie.</small>
    const labelCheckPhone = <small>Wyrażam zgodę na otrzymywanie od ROMER S.C. A.CIURA W.CIURA z siedzibą przy ul. Rejowska 99, 26-110 Skarżysko-Kamienna, za pomocą telefonu, na podany przeze mnie numer telefonu, informacji handlowych związanych z działalnością Spółki, w szczególności informacji o produktach oferowanych przez ROMER S.C. A.CIURA W.CIURA. Powyższa zgoda może być wycofana w dowolnym momencie.</small>

    const [customClass, setCustomClass] = useState("my-3 overflow-y-scroll h-25 vh-25 hideScroll hideScrollBlur")

    const rulesCheckbox = useRef(null);
    const privacyCheckbox = useRef(null);

    const { setSiteState } = useContext(CheckoutContext);
    useEffect(() => {
        setSiteState({
            rulesRef: rulesCheckbox?.current,
            privacyRef: privacyCheckbox?.current,
        });
    }, [rulesCheckbox, privacyCheckbox]);

    return (
        <Container className={customClass} onScroll={(e) => {

            const target = e.target as HTMLTextAreaElement
            if (target.scrollTop > 50) {
                setCustomClass("my-3 overflow-y-scroll h-25 vh-25 hideScroll")
            } else {
                setCustomClass("my-3 overflow-y-scroll h-25 vh-25 hideScroll hideScrollBlur")
            }
        }}>
            <CustomCheckbox id="checkStatute" label={labelCheckRules} ref={rulesCheckbox} required={true} />
            <CustomCheckbox id="checkPolicy" label={labelCheckPolicy} ref={privacyCheckbox} required={true} />
            <CustomCheckbox id="checkMail" label={labelCheckMail} />
            <CustomCheckbox id="checkPhone" label={labelCheckPhone} />
        </Container>
    )
}

function CustomCheckbox({ id, label, required = false, ref = null }: {
    id: string,
    label: ReactElement | string,
    required?: boolean,
    ref?: any
}) {
    const dispatch = useAppDispatch();
    const checked = useAppSelector((state) => state.checkout.rules[id] || false);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        dispatch(setRules({ id, value: event.target.checked }));
    };

    return (
        <Row className="mb-2">
            <Col className="text-end p-0 customCheckbox" xs={1}>
                <input id={id} checked={checked} onChange={handleChange} className="form-check-input"
                    type="checkbox" ref={ref} required={required} />
            </Col>
            <Col className="pe-4">
                <label htmlFor={id}>
                    {label}
                </label>
            </Col>
        </Row>
    )
}